import React, { useEffect } from 'react';
import {
  // 日期筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 单选、多选国家筛选器
  COMPOSED_COUNTRY_SELECT as FILTER_COMPOSED_COUNTRY_SELECT,
  // 品类筛选器
  GENRETOR as FILTER_GENRE_SELECT,
} from '@intelligence/components/Filter/FilterBase/_config';
import { STATIC_FILTER_CONFIGS } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overlap/components/Filter/_config';

import type { IRegion } from '@intelligence/types/common';

export default function useUpdateFiltersCfg(props: {
  loading?: boolean;
  rangePickerDisabledMap?: IDateRangeDisabledCallbackDateTypeMap | null;
  regionsOptions: IRegion[];
  countryFilterTip: string;
  genreOptions?: any;
  inputList: any[];
  setInputList: React.Dispatch<React.SetStateAction<any[]>>;
}) {
  const { loading, rangePickerDisabledMap, regionsOptions, countryFilterTip, genreOptions, inputList, setInputList } = props || {};

  // 更新日期筛选器
  const updateRangeTimeSelect = (
    inputItem: any,
    rangePickerDisabledMap?: IDateRangeDisabledCallbackDateTypeMap | null,
  ): any => {
    if (!inputItem) return inputItem;
    return {
      ...inputItem,
      disabledDate: rangePickerDisabledMap?.daily,
      disabledWeek: rangePickerDisabledMap?.weekly,
      disabledMonth: rangePickerDisabledMap?.monthly,
    };
  };

  // 更新国家筛选器
  const updateComposedCountrySelect = (inputItem: any, regionsOptions: IRegion[], hoverTip: string): any => {
    if (!inputItem) return STATIC_FILTER_CONFIGS.COMPOSED_COUNTRY_SELECT;
    return {
      ...inputItem,
      options: Array.isArray(regionsOptions) ? regionsOptions : [],
      hoverTip,
    };
  };

  /**
   * @date 2025/01/21
   * @description 更新品类筛选器
   * @author lv.chen
   */
  const updateGenreSelect = (inputItem: any, loading?: boolean, genreOptions?: any): any => {
    if (!inputItem) return inputItem;
    return {
      ...inputItem,
      loading,
      genresOptionsDataLoading: loading,
      genresOptionsData: genreOptions,
      genreOptions,
    };
  };

  useEffect(() => {
    if (loading) return;
    if (!Array.isArray(inputList)) return;
    const inputListTmp = inputList.map((inputItem) => {
      // 更新日期筛选器的禁用日期
      if (inputItem?.key === FILTER_RANGE_TIME) {
        return updateRangeTimeSelect(inputItem, rangePickerDisabledMap);
      }

      // 更新国家筛选器列表
      if (inputItem?.key === FILTER_COMPOSED_COUNTRY_SELECT) {
        return updateComposedCountrySelect(inputItem, regionsOptions, countryFilterTip);
      }

      // 更新品类筛选器
      if (inputItem?.key === FILTER_GENRE_SELECT) {
        return updateGenreSelect(inputItem, loading, genreOptions);
      }

      // 其余不需要更新的控件
      return inputItem;
    });
    setInputList(inputListTmp);
  }, [loading, rangePickerDisabledMap, regionsOptions, countryFilterTip, genreOptions]);
}
